import React, { Fragment } from 'react';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom'
import { ReactComponent as LogoWhite } from "~/assets/images/logo/logo-white.svg";
import { ReactComponent as LogoRed } from "~/assets/images/logo/logo-red.svg";

const Leftbar = ({expanded})=> {

  return (
    <Fragment>
      <Col size={6} className="header-logo-wrapper">
        <Link to='/dashboard'>
         {  expanded && <LogoWhite  style={{ maxWidth : 110 }} /> }
         { !expanded && <LogoRed  style={{ maxWidth : 110 }} /> }
        </Link>
      </Col>
    </Fragment>
  );

}

export default Leftbar;
